import { Callback, requestAction } from "../actionlog/actionLogActions"
import {MatrixAxis} from "./matrix/Matrix"
import Product from "./Product"
import ProductService from "./ProductService"
import {
    ProductUpdatePayload,
    PRODUCT_CLEARED,
    PRODUCT_LOADED,
    PRODUCT_UPDATED,
    MATRIX_AXIS_UPDATED,
    MATRIX_AXIS_TYPE,
    MATRIX_ITEM_UPDATED,
    MatrixItemUpdatePayload,
    MATRIX_AXIS_DELETED,
    MatrixItemPayload,
    MATRIX_ITEM_DELETED, 
    MATRIX_ITEM_RESTORED, 
    MODIFY_BUNDLE
} from "./Types"
import { BundleItem } from "./bundle/models/BundleItem"
import { bundleAddItem, bundleRemoveItem, bundleUpdateItem } from "./bundle/actions"

export function provision(product) {
    return {
        type: PRODUCT_LOADED,
        payload: product
    }
}

export function provisionAction(product: Product) {
    return {
        type: PRODUCT_LOADED,
        payload: product.getAttributes()
    } 
}

export function clear() {
    return {
        type: PRODUCT_CLEARED,
    }
}

export function updateProduct(payload: ProductUpdatePayload) {
    return {
        type: PRODUCT_UPDATED,
        payload: payload
    }
}

export function updateMatrixAxis(axis: MatrixAxis) {
    return {
        type: MATRIX_AXIS_UPDATED,
        payload: axis
    }
}

export function deleteMatrixAxis(axisType: MATRIX_AXIS_TYPE) {
    return {
        type: MATRIX_AXIS_DELETED,
        payload: axisType
    }
}

export function updateMatrixItem(payload: MatrixItemUpdatePayload) {
    return {
        type: MATRIX_ITEM_UPDATED,
        payload: payload
    }
}


export function deleteMatrixItem(payload: MatrixItemPayload) {
    return {
        type: MATRIX_ITEM_DELETED,
        payload: payload
    }
}

export function restoreMatrixItem(payload: MatrixItemPayload) {
    return {
        type: MATRIX_ITEM_RESTORED,
        payload: payload
    }
}

export function createProductAction(actionId: string, payload: object) {
    return async dispatch => {
        dispatch(
            requestAction<Product>(
                () => ProductService.create(payload),
                provisionAction as Callback<Product>,
                actionId,
            )
        )
    }
}

export function updateProductAction(actionId:string, productId: string, payload: object) {
    return async dispatch => {
        dispatch(
            requestAction<Product>(
                () => ProductService.update(payload, productId),
                provisionAction as Callback<Product>,
                actionId,
            )
        )   
    }
}

export function fetchProductAction(actionId: string, productId: string) {
    return async dispatch => {
        dispatch(
            requestAction<Product>(
                () => ProductService.getProduct(productId),
                provisionAction as Callback<Product>,
                actionId,
            )
        )   
    }
}

export function deleteProductAction(actionId: string, productId: string) {
    return async dispatch => {
        dispatch(
            requestAction<Product>(
                () => ProductService.delete(productId),
                () => clear,
                actionId,
            )
        )   
    }
}

export function addBundleItem(payload: BundleItem) {
    return {
        type: MODIFY_BUNDLE,
        payload: bundleAddItem(payload)
    }
}

export function removeBundleItem(payload: BundleItem) {
    return {
        type: MODIFY_BUNDLE,
        payload: bundleRemoveItem(payload)
    }
}

export function updateBundleItem(payload: BundleItem[]) {
    return {
        type: MODIFY_BUNDLE,
        payload: bundleUpdateItem(payload)
    }
}


// WEBPACK FOOTER //
// ./src/state/product/ProductActions.ts